import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import RoundRobinUniversalIndex from './Index.vue';

// V1 · Round Robin Universal · 2026-05-13 (Victor)
// Página accesible solo a super_admin · gate adicional dentro del componente
// (onMounted redirect si no es super_admin). El permission 'administrator'
// del meta cubre lectura básica · super_admin verifica la página y el backend.
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/round-robin-universal'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_round_robin_universal',
          component: RoundRobinUniversalIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
